var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V20H20V0ZM6.20689 3.44828L9.52932 4.61112L6.20689 5.51724V7.58621L9.52932 8.74906L6.20689 9.65517V11.7241L9.65517 12.931L6.20689 13.7931V15.8621L13.1034 18.2759V16.2069L9.65517 15L13.1034 14.1379V12.069L9.65517 10.8621L13.1034 10V7.93103L9.65517 6.72414L13.1034 5.86207V3.7931L6.20689 1.37931V3.44828Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinLayer);
export default __webpack_public_path__ + "static/media/ProteinLayer.9a7b6025cad64bebfe064210276bd0f8.svg";
export { ForwardRef as ReactComponent };